import styled from "styled-components";

import type { FontVariant } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

export const StyledTextOverflow = styled.div<{ fontVariant: FontVariant; color: string }>`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    ${({ fontVariant, color }) => setFontVariant(fontVariant, color)}
`;
